import PowerBankMapCard from './PowerBankMapCard'

export default PowerBankMapCard
